import { Tooltip, Toast,Modal,Offcanvas} from 'bootstrap';
import AOS from 'aos';
import GLightbox from 'glightbox';

const lightbox = GLightbox({
    selector: ".glightbox",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
// import gsap from "gsap";
AOS.init({
    duration: 1000,
    once: true,
});
let isClosed = false;
let lastScrollTop = 0;
let body=document.querySelector("body");
let burgerMenu = document.querySelector("#hamburger")
let btnLanguage=document.querySelectorAll('.navbar-custom__btn-language');
let btnToggler=document.querySelector('.navbar-custom__toggler');
const dropdowns = document.querySelectorAll(".dropdown")


window.addEventListener("load", (event) => {
	if (window.innerWidth >=992 ) {
        hoverDropdown();
  }
  // gsap.fromTo(
  //   ".preloader",
  //   { duration:1, autoAlpha:1},
  //   { duration:1, autoAlpha:0}
  // );
});

window.addEventListener("resize", function(){
    if (window.innerWidth >=992 ) {
		hoverDropdown();
	}
});

btnToggler.addEventListener('click', ()=>{  
  burgerTime() 
});

onscroll = (event) => { 
  stikynav();
};

//3. Function Area
function burgerTime() {
  if (isClosed== true) {
      closeSideMenu();
  } else {
      openSideMenu()
  }
}

function openSideMenu(){
  burgerMenu.classList.remove("closed");
  burgerMenu.classList.add("open");
  body.classList.add('no-scroll');
  isClosed = true;
}

function closeSideMenu(){
  burgerMenu.classList.remove("open");
  burgerMenu.classList.add("closed");
  body.classList.remove('no-scroll');
  isClosed  = false;
}

function hoverDropdown(){
    for (const dropdown of dropdowns) {
        dropdown.addEventListener('mouseenter', function(event) {
            let target=event.target
            let dropdownToggle=target.querySelector('.dropdown-toggle')
            let dropdownMenu=target.querySelector('.dropdown-menu')
            target.classList.add('show');
            dropdownToggle.classList.add('show');
            dropdownMenu.classList.add('show');
        })
        dropdown.addEventListener('mouseleave', function(event) {
            let target=event.target
            let dropdownToggle=target.querySelector('.dropdown-toggle')
            let dropdownMenu=target.querySelector('.dropdown-menu')
            target.classList.remove('show');
            dropdownToggle.classList.remove('show');
            dropdownMenu.classList.remove('show');
        })
    }
}

function stikynav(){
  const navHeader = document.querySelector('.navbar-custom');
  let currentScrollPos = window.scrollY;

  setTimeout(function(){
      if(currentScrollPos<=0){
          navHeader.classList.remove('hide');
          navHeader.classList.remove('show');
      }
      else if(currentScrollPos > lastScrollTop){
          navHeader.classList.add('hide');
          navHeader.classList.remove('show');
      } else {
          navHeader.classList.add('show');
          navHeader.classList.remove('hide');
      }
      lastScrollTop = currentScrollPos;
  }, 100);

//   if(currentScrollPos>750){
//       scrollToTopBtn.classList.add('active')
//   }else{
//       scrollToTopBtn.classList.remove('active')
//   }
}

document.addEventListener("DOMContentLoaded", function(){
        

    /////// Prevent closing from click inside dropdown
    document.querySelectorAll('.dropdown-menu').forEach(function(element){
        element.addEventListener('click', function (e) {
          e.stopPropagation();
        });
    })



    // make it as accordion for smaller screens
    if (window.innerWidth < 992) {

        // close all inner dropdowns when parent is closed
        document.querySelectorAll('.navbar .dropdown').forEach(function(everydropdown){
            everydropdown.addEventListener('hidden.bs.dropdown', function () {
                // after dropdown is hidden, then find all submenus
                  this.querySelectorAll('.submenu').forEach(function(everysubmenu){
                      // hide every submenu as well
                      everysubmenu.style.display = 'none';
                  });
            })
        });
        
        document.querySelectorAll('.dropdown-menu a').forEach(function(element){
            element.addEventListener('click', function (e) {
    
                  let nextEl = this.nextElementSibling;
                  if(nextEl && nextEl.classList.contains('submenu')) {	
                      // prevent opening link if link needs to open dropdown
                      e.preventDefault();
                      console.log(nextEl);
                      if(nextEl.style.display == 'block'){
                          nextEl.style.display = 'none';
                      } else {
                          nextEl.style.display = 'block';
                      }

                  }
            });
        })
    }
    // end if innerWidth

}); 
// DOMContentLoaded  end



